export default {
  title: 'Links',

  short: {
    title: 'Short links'
  },

  domains: {
    title: 'Domains'
  },

  presets: {
    title: 'Presets'
  },

  tracking: {
    title: 'Transitions'
  }
}
